import { useTranslation } from 'next-i18next';
import { BulbColorIcon, CheckSmallIcon, TrashIcon } from '@/icons';
import { Button, IconButton } from '@/ui_v3';
import { type BuildQuizListItem } from '@/views/build/form/schema/BuildQuizListSchema';
import { HintInput } from './input/HintInput';
import { type HintType } from './type';
export const HintCard = ({
  hint,
  onChange
}: {
  hint: NonNullable<BuildQuizListItem['hint']>;
  onChange: (value: BuildQuizListItem['hint']) => void;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const handleDelete = () => {
    onChange(undefined);
  };
  return <article className="flex w-full flex-col gap-md overflow-hidden rounded-[16px] border border-opacity bg-default pb-md" data-sentry-component="HintCard" data-sentry-source-file="HintCard.tsx">
      <header className="flex items-center justify-between bg-yellow-50 px-md pb-3xs pt-2xs">
        <div className="flex items-center gap-3xs">
          <BulbColorIcon size="xs" data-sentry-element="BulbColorIcon" data-sentry-source-file="HintCard.tsx" />
          <div className="text-body-md-bold font-bold text-gray-700">
            {t('common:quizItem.hint.title')}
          </div>
        </div>
        <IconButton variant="transparent" intent="neutral" size="xs" onClick={e => {
        e.stopPropagation();
        handleDelete();
      }} data-sentry-element="IconButton" data-sentry-source-file="HintCard.tsx">
          <TrashIcon size="xs" data-sentry-element="TrashIcon" data-sentry-source-file="HintCard.tsx" />
        </IconButton>
      </header>
      <div className="flex w-full flex-col gap-sm px-md">
        <HintTypeSelector type={hint.type} onSelect={type => {
        onChange({
          value: '',
          type
        });
      }} data-sentry-element="HintTypeSelector" data-sentry-source-file="HintCard.tsx" />
        <HintInput type={hint.type} value={hint.value} onChange={value => onChange({
        ...hint,
        value
      })} data-sentry-element="HintInput" data-sentry-source-file="HintCard.tsx" />
      </div>
    </article>;
};
const HintTypeSelector = ({
  type,
  onSelect
}: {
  type: HintType;
  onSelect: (type: HintType) => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const hintTypes = [{
    type: 'text',
    label: t('quizCreateItem.hintType.text')
  }, {
    type: 'image',
    label: t('quizCreateItem.hintType.image')
  }, {
    type: 'youtube',
    label: t('quizCreateItem.hintType.youtube')
  }] as {
    type: HintType;
    label: string;
  }[];
  return <div className="flex flex-row items-center justify-start gap-3xs" data-sentry-component="HintTypeSelector" data-sentry-source-file="HintCard.tsx">
      {hintTypes.map(t => <Button variant={'outlined'} intent={type === t.type ? 'alternative' : 'neutral'} rounded="full" key={t.type} onMouseDown={e => {
      e.preventDefault();
    }} onClick={e => {
      e.stopPropagation();
      onSelect(t.type);
    }} rightSlot={type === t.type ? <CheckSmallIcon size="sm" /> : <></>} size="sm">
          {t.label}
        </Button>)}
    </div>;
};